import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'Login',
            component: () => import('../components/Login.vue')
        },
        {
            path: '/recentactivity',
            name: 'RecentActivity',
            component: () => import('../components/RecentActivity.vue')
        },
        {
            path: '/globalsearch/:searchText',
            name: 'GlobalSearchView',
            component: () => import('../components/GlobalSearchView.vue'),
            props: true
        },
        {
            path: '/user/list',
            name: 'UserList',
            component: () => import('../components/backend/user/ListUser.vue')
        },
        {
            path: '/changeprofile',
            name: 'ChangeProfile',
            component: () => import('../components/backend/user/ChangeProfile.vue')
        },
        {
            path: '/parts-sales/list',
            name: 'ListUploadPartsSales',
            component: () => import('../components/ListUploadPartsSales.vue')
        },
        {
            path: '/parts-sales/reports',
            name: 'PartsSalesReport',
            component: () => import('../components/PartsSalesReport.vue')
        },
        {
            path: '/updateusers/:id',
            name: 'AddUpdateUsers',
            component: () => import('../components/backend/user/AddUpdateUsers.vue')
        },
        {
            path: '/roreversal/list',
            name: 'ListROReversalRequest',
            component: () => import('../components/Forms/ROReversalRequest/ListROReversalRequest.vue')
        },
        {
            path: '/roreversal/add',
            name: 'AddUpdateROReversalRequest',
            component: () => import('../components/Forms/ROReversalRequest/AddUpdateROReversalRequest.vue')
        },
        {
            path: '/roreversal/edit/:id',
            name: 'UpdateROReversalRequest',
            component: () => import('../components/Forms/ROReversalRequest/AddUpdateROReversalRequest.vue')
        },
        {
            path: '/techtime/list',
            name: 'ListTechTime',
            component: () => import('../components/Forms/TechTimeMaster/ListTechTime.vue')
        },
        {
            path: '/techtime/add',
            name: 'AddUpdateTechTime',
            component: () => import('../components/Forms/TechTimeMaster/AddUpdateTechTime.vue')
        },
        {
            path: '/dayforace/time/list',
            name: 'ListDayforaceTimeEditRequest',
            component: () => import('../components/Forms/DayforaceTimeEditRequest/ListDayforaceTimeEditRequest.vue')
        },
        {
            path: '/dayforace/time/add',
            name: 'AddUpdateDayforaceTimeEditRequest',
            component: () => import('../components/Forms/DayforaceTimeEditRequest/AddUpdateDayforaceTimeEditRequest.vue')
        },
        {
            path: '/dayforace/time/spanish/list',
            name: 'ListSpanishDayforaceTimeEditRequest',
            component: () => import('../components/Forms/DayforaceTimeEditRequest/ListSpanishDayforaceTimeEditRequest.vue')
        },
        {
            path: '/dayforace/time/spanish/add',
            name: 'AddUpdateSpanishDayforaceTimeEditRequest',
            component: () => import('../components/Forms/DayforaceTimeEditRequest/AddUpdateSpanishDayforaceTimeEditRequest.vue')
        },

        {
            path: '/par/request/list',
            name: 'ListPARRequest',
            component: () => import('../components/Forms/PARRequest/ListPARRequest.vue')
        },
        {
            path: '/par/request/add',
            name: 'AddUpdatePARRequest',
            component: () => import('../components/Forms/PARRequest/AddUpdatePARRequest.vue')
        },
        {
            path: '/par/request/edit/:id',
            name: 'UpdatePARRequest',
            component: () => import('../components/Forms/PARRequest/AddUpdatePARRequest.vue')
        },
        {
            path: '/par/request/view/:id',
            name: 'ViewPARRequest',
            component: () => import('../components/Forms/PARRequest/ViewPARRequest.vue')
        },
        {
            path: '/form/email/manager/list',
            name: 'ListFormEmailManager',
            component: () => import('../components/Forms/FormEmailManager/ListFormEmailManager.vue')
        },
        {
            path: '/form/email/manager/add',
            name: 'AddUpdateFormEmailManager',
            component: () => import('../components/Forms/FormEmailManager/AddUpdateFormEmailManager.vue')
        },
        {
            path: '/form/email/manager/edit/:id',
            name: 'UpdateFormEmailManager',
            component: () => import('../components/Forms/FormEmailManager/AddUpdateFormEmailManager.vue')
        },
        {
            path: '/vendor/item/list',
            name: 'ListVendor',
            component: () => import('../components/Forms/VendorMaster/ListVendor.vue')
        },
        {
            path: '/vendor/item/add',
            name: 'AddUpdateVendor',
            component: () => import('../components/Forms/VendorMaster/AddUpdateVendor.vue')
        },
        {
            path: '/vendor/item/edit/:id',
            name: 'UpdateVendor',
            component: () => import('../components/Forms/VendorMaster/AddUpdateVendor.vue')
        },
        {
            path: '/office/supplier/list',
            name: 'ListOfficeSupplier',
            component: () => import('../components/Forms/OfficeSupplier/ListOfficeSupplier.vue')
        },
        // office supplies add
        {
            path: '/office/supplier/add',
            name: 'AddUpdateOfficeSupplier',
            component: () => import('../components/Forms/OfficeSupplier/AddUpdateOfficeSupplier.vue')
        },
        {
            path: '/office/supplier/edit/:id',
            name: 'UpdateOfficeSupplier',
            component: () => import('../components/Forms/OfficeSupplier/AddUpdateOfficeSupplier.vue')
        },
        //warehouse supplies
        {
            path: '/warehouse/order/supplier/add',
            name: 'AddUpdateWarehouseOrderSupplies',
            component: () => import('../components/Forms/WarehouseOrderSupplies/AddUpdateWareHouseOrderSupplies.vue')
        },
        {
            path: '/warehouse/order/supplier/edit/:id',
            name: 'UpdateWarehouseOrderSupplies',
            component: () => import('../components/Forms/WarehouseOrderSupplies/AddUpdateWareHouseOrderSupplies.vue')
        },
        {
            path: '/warehouse/order/supplier/list',
            name: 'ListWareHouseOrderSupplies',
            component: () => import('../components/Forms/WarehouseOrderSupplies/ListWareHouseOrderSupplies.vue')
        },
        {
            path: '/hrdragview',
            name: 'HRDragView',
            component: () => import('../components/backend/user/HRDragView.vue')
        },
        {
            path: '/:type',
            name: 'CommonPage',
            component: () => import('../components/CommonPage.vue')
        },
        /* NOTE: Deprecated CommonPageOld Route As Not In Use (BS - 07/08/2024) */
        /* {
            path: '/:type/test',
            name: 'CommonPageOld',
            component: () => import('../components/CommonPageOld.vue')
        }, */
        {
            path: '/:type/view',
            name: 'CommonPostDetail',
            component: () => import('../components/CommonPostDetail.vue')
        },
        {
            path: '/:type/add_post',
            name: 'DiscussionAddForm',
            component: () => import('../components/DiscussionAddForm.vue')
        },
        {
            path: '/:type/edit_post/:id',
            name: 'DiscussionEditForm',
            component: () => import('../components/DiscussionAddForm.vue')
        },
        {
            path: '/:type/add_attachment',
            name: 'AttachmentAddForm',
            component: () => import('../components/AttachmentAddForm.vue')
        },
        {
            path: '/:type/edit_attachment/:id',
            name: 'AttachmentEditForm',
            component: () => import('../components/AttachmentAddForm.vue')
        },
        {
            path: '/:type/add_date',
            name: 'EventAddForm',
            component: () => import('../components/EventAddForm.vue')
        },
        {
            path: '/:type/edit_date/:id',
            name: 'EventEditForm',
            component: () => import('../components/EventAddForm.vue')
        },
        {
            path: '/menu/add-edit-menu',
            name: 'AddEditMenu',
            component: () => import('../components/AddEditMenu.vue')
        },
        /*{
            path: '/user/list',
            name: 'UserList',
            // component: UserList
            component: () => import('../components/UserList.vue')
        },*/
        {
            path: '/key/list',
            name: 'ListCalendarKey',
            component: () => import('../components/ListCalendarKey.vue')
        },
        {
            path: '/key/add',
            name: 'AddCalendarKey',
            component: () => import('../components/AddCalendarKey.vue')
        },
        {
            path: '/key/edit/:id',
            name: 'EditCalendarKey',
            component: () => import('../components/AddCalendarKey.vue')
        },
        {
            path: '/attachment-group/list',
            name: 'ListAttachmentGroup',
            component: () => import('../components/ListAttachmentGroup.vue')
        },
        {
            path: '/attachment-group/add',
            name: 'AddAttachmentGroup',
            component: () => import('../components/AddAttachmentGroup.vue')
        },
        {
            path: '/attachment-group/edit/:id',
            name: 'EditAttachmentGroup',
            component: () => import('../components/AddAttachmentGroup.vue')
        },
        {
            path: '/office/supplier/view/:id',
            name: 'ViewOfficeSupplier',
            component: () => import('../components/Forms/OfficeSupplier/ViewOfficeSupplier.vue')
        },
        {
            path: '/warehouse/order/supplier/view/:id',
            name: 'ViewWarehouseOrderSupplies',
            component: () => import('../components/Forms/WarehouseOrderSupplies/ViewWarehouseOrderSupplies.vue')
        },
        {
            path: '/restocking/fee/list',
            name: 'ListRestockingFee',
            component: () => import('../components/Forms/RestockingFee/ListRestockingFee.vue')
        },
        {
            path: '/restocking/fee/add',
            name: 'AddUpdateRestockingFee',
            component: () => import('../components/Forms/RestockingFee/AddUpdateRestockingFee.vue')
        },
        {
            path: '/restocking/fee/edit/:id',
            name: 'UpdateRestockingFee',
            component: () => import('../components/Forms/RestockingFee/AddUpdateRestockingFee.vue')
        },
        {
            path: '/travel/request/list',
            name: 'ListTravelRequest',
            component: () => import('../components/Forms/TravelRequestMaster/ListTravelRequest.vue')
        },
        {
            path: '/uniform/request/list',
            name: 'ListUniformRequestForm',
            component: () => import('../components/Forms/UniformRequest/ListUniformRequestForm.vue')
        },
        {
            path: '/uniform/request/add',
            name: 'AddUpdateUniformRequestForm',
            component: () => import('../components/Forms/UniformRequest/AddUpdateUniformRequestForm.vue')
        },
        {
            path: '/dispute/chargeback/list',
            name: 'ListDisputeChargebackRequest',
            component: () => import('../components/Forms/DisputeChargebackMaster/ListDisputeChargebackRequest.vue')
        },
        {
            path: '*',
            name: 'PageNotFound',
            component: () => import('../components/PageNotFound.vue')
        }
    ]
});
